import cx from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'reactstrap';

import { PageLoader } from '../../_components';
import { Button } from '../../_components/button';
import { useCheckSession } from '../../_components/use-check-session';

import styles from './styles.module.scss';

export function LandingPage() {
  const { loading } = useCheckSession();

  const navigate = useNavigate();
  if (loading) return <PageLoader />;

  return (
    <Container
      className="justify-content-start d-flex flex-column"
      fluid
      style={{ maxWidth: '600px', minHeight: '700px' }}
    >
      <div className="d-flex flex-column justify-content-start align-items-start">
        <h1 className="mt-4 mb-4">Precertification Portal</h1>
        <div className={cx(styles.alert, 'alert alert-info mb-4')}>
          Community providers should use the VA Precertification Portal (VAPP)
          to determine, create, and submit services that require
          precertification to VA prior to rendering those services. Upon
          successful completion of a precertification notification in the VAPP,
          the provider will receive a unique precertification ID via email at
          the time of submission.
        </div>
      </div>
      <>
        <div className="d-flex flex-column mt-3">
          <h2 tabIndex={0} className="fw-bold h6 mb-4 text-center">
            Please select an option
          </h2>
          <div className="d-flex justify-content-center">
            <Button
              onClick={() => navigate('/form/new-request')}
              className="me-2"
              color="success"
              aria-label="Create"
              aria-description="Press enter to create a new Precertification"
            >
              Create a New Precertification
            </Button>
            <Button
              onClick={() => navigate('/update')}
              color="primary"
              aria-label="Update"
              aria-description="Press enter to update an existing Precertification"
            >
              Update an Existing Precertification
            </Button>
          </div>
        </div>
      </>
    </Container>
  );
}
